import React from 'react'
import BEMHelper from '@ynap/bem-helper'
import { useMessages } from '@ynap/immutables-provider'
import { Notification } from '@ynap/notification'

const bem = new BEMHelper('ShippingSummary')

const ShippingSummary = (props) => {
    const { className, shippingOption, shippingOptionJit, shippingOptionInfo, shippingOptionInfoJit, isPostSplit, withPrice = true } = props

    const messages = useMessages()
    const { getRequestedSlot, currentSignatureRequired } = shippingOptionInfo || {}
    const { currentSignatureRequired: currentSignatureRequiredJit } = shippingOptionInfoJit || {}

    const renderShippingOption = ({ name, description = [], finalShippingPrice }) => (
        <>
            {name && <li className={bem('bulleted')}>{withPrice ? `${name} - ${finalShippingPrice}` : name}</li>}
            {description.map((line, index) => (
                <li key={index} className={bem('notBulleted')}>
                    {line}
                </li>
            ))}
        </>
    )

    const jitShippingOptionVisible = isPostSplit && shippingOptionJit

    return (
        <ul className={bem(null, null, className)}>
            {jitShippingOptionVisible && <div className={bem('splitHeader')}>{messages.basket.jit.header?.({ step: 1 })}</div>}
            {renderShippingOption(shippingOption || {})}
            {getRequestedSlot && <li>{getRequestedSlot(messages.shippingOptionsForm.relativeDay).label}</li>}
            {jitShippingOptionVisible && (
                <>
                    <Notification className={bem('postshipDivider')} type="info-globe-sm" message={messages.basket.jit.summary?.()} />
                    <div className={bem('splitHeader')}>{messages.basket.jit.header?.({ step: 2 })}</div>
                    {renderShippingOption(shippingOptionJit || {})}
                </>
            )}
            {currentSignatureRequired === 'Y' || currentSignatureRequiredJit === 'Y'
                ? <li className={bem('bulleted')}>{messages.shippingOptionsStep.signatureRequired()}</li>
                : messages.shippingOptionsStep.noSignatureRequired?.() ? <li className={bem('bulleted')}>{messages.shippingOptionsStep.noSignatureRequired()}</li> : null}
        </ul>
    )
}

export default ShippingSummary
